(function(){
    'use strict';

    angular.module('tmx-app')
        .directive('exportPdf', [exportPdf]);

    function exportPdf() {

        var directive={
            restrict: 'E',
            scope: {
                kendogrid: '='
            },
            templateUrl: 'common/directives/exportPdf/exportPdf.html',
            controller: ["$scope",exportPdfCtrl],
       /* controller:function($scope){

        },*/
            controllerAs:'exportPdfCtrl'
        };
        return directive; 
    }

    function exportPdfCtrl($scope){
        var vm=this;
        vm.scope=$scope;

        vm.exportPdf=function(){
            var lastIndex=vm.scope.kendogrid.columns.length-1;
            vm.scope.kendogrid.hideColumn(lastIndex);
            vm.scope.kendogrid.saveAsPDF();
            vm.scope.kendogrid.showColumn(lastIndex);
        }
    }


})();